/**
 * Marketplace Analytics — lightweight event tracking.
 * Non-blocking: never throws or blocks UI.
 */

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function trackEvent(event, payload = {}, userId = null) {
  try {
    const body = { event, payload, user_id: userId };
    const url = `${API_URL}/api/analytics/event`;
    const blob = new Blob([JSON.stringify(body)], { type: 'application/json' });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    // Silent fail — analytics must never block UX
  }
}

// Legacy helpers (kept for backward compat)
export const trackListingView = (adId) => trackEvent('ad_view', { adId, ad_id: adId });
export const trackContactClick = (adId, type) => trackEvent('contact_seller', { adId, ad_id: adId, method: type });
export const trackWhatsAppClick = (adId) => trackEvent('contact_seller', { adId, ad_id: adId, method: 'whatsapp' });
export const trackPhoneClick = (adId) => trackEvent('contact_seller', { adId, ad_id: adId, method: 'phone' });
export const trackShareClick = (adId) => trackEvent('share_click', { adId, ad_id: adId });
export const trackSearchQuery = (query) => trackEvent('search_submit', { query });
export const trackSearchResultClick = (adId, query) => trackEvent('ad_open', { adId, ad_id: adId, query });
export const trackFavorite = (adId) => trackEvent('favorite_add', { adId, ad_id: adId });
